/* Marjo et son petit robot pref 🤖
   Gère la quantité, la sélection de couleur et l'ajout au panier Ajax
   sur les cartes produits de la collection Pictogrammes.

   Problème réglé :
   Permet l'achat directement depuis la collection et met à jour
   immédiatement le compteur du panier, même lorsque le mini-panier
   est désactivé.

   Page touchée : collection pictogrammes.
   App impliquée : aucune.
*/

document.addEventListener('click', function(event) {
  const minusBtn = event.target.closest('[data-mac-picto-qty-minus]');
  const plusBtn = event.target.closest('[data-mac-picto-qty-plus]');
  const addToCartBtn = event.target.closest('[data-mac-picto-add-to-cart]');
  const swatch = event.target.closest('color-swatch');

  if (minusBtn || plusBtn) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const card = event.target.closest('[data-mac-picto-card]');
    if (!card) return;

    const qtyValue = card.querySelector('[data-mac-picto-qty-value]');
    if (!qtyValue) return;

    let quantity = parseInt(qtyValue.textContent, 10) || 1;

    if (plusBtn) quantity += 1;
    if (minusBtn && quantity > 1) quantity -= 1;

    qtyValue.textContent = quantity;
    return;
  }

  if (addToCartBtn) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const card = addToCartBtn.closest('[data-mac-picto-card]');
    if (!card) return;

    const variantId = card.dataset.selectedVariantId;
    const qtyValue = card.querySelector('[data-mac-picto-qty-value]');
    const quantity = parseInt(qtyValue?.textContent, 10) || 1;
    const cardWrapper = card.closest('.card-wrapper');
    const swatchGroup = cardWrapper?.querySelector('.card__colors');

    if (!variantId) {
      if (swatchGroup) {
        swatchGroup.classList.add('mac-picto-swatch-error');
      }
      return;
    }

    const miniCart = document.querySelector('mini-cart');

    const sections = miniCart
      ? miniCart.getSectionsToRender().map(function(section) {
          return section.id;
        })
      : ['cart-icon-bubble', 'mobile-cart-icon-bubble'];

    const cartAddUrl =
      window.theme?.routes?.cart_add_url || '/cart/add.js';

    addToCartBtn.setAttribute('disabled', 'disabled');

    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Erreur ajout panier');
      }

      return response.json();
    })
    .then(function(parsedState) {
      if (miniCart && parsedState.sections) {
        miniCart.renderContents(parsedState);
      } else if (parsedState.sections) {
        [
          'cart-icon-bubble',
          'mobile-cart-icon-bubble'
        ].forEach(function(sectionId) {
          const target = document.getElementById(sectionId);
          const sectionHtml = parsedState.sections[sectionId];

          if (!target || !sectionHtml) return;

          const parsedHtml = new DOMParser().parseFromString(
            sectionHtml,
            'text/html'
          );

          const sectionWrapper = parsedHtml.querySelector(
            '.shopify-section'
          );

          target.innerHTML = sectionWrapper
            ? sectionWrapper.innerHTML
            : parsedHtml.body.innerHTML;
        });
      }

      addToCartBtn.textContent = 'Ajouté';

      setTimeout(function() {
        addToCartBtn.textContent = 'Ajouter au panier';
      }, 1500);
    })
    .catch(function(error) {
      console.error(error);

      addToCartBtn.textContent = 'Erreur';

      setTimeout(function() {
        addToCartBtn.textContent = 'Ajouter au panier';
      }, 1500);
    })
    .finally(function() {
      addToCartBtn.removeAttribute('disabled');
    });

    return;
  }

  if (swatch && swatch.closest('.card-wrapper')) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const cardWrapper = swatch.closest('.card-wrapper');
    const swatchGroup = swatch.closest('.card__colors');

    if (!cardWrapper || !swatchGroup) return;

    swatchGroup
      .querySelectorAll('color-swatch')
      .forEach(function(item) {
        item.classList.remove('mac-picto-swatch-selected');
      });

    swatch.classList.add('mac-picto-swatch-selected');
    swatchGroup.classList.remove('mac-picto-swatch-error');

    const cartBlock = cardWrapper.querySelector(
      '[data-mac-picto-card]'
    );

    if (cartBlock && swatch.dataset.variantId) {
      cartBlock.dataset.selectedVariantId =
        swatch.dataset.variantId;
    }

    return;
  }
}, true);